function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

import React, { Component } from 'react';
import ReactDOM from 'react-dom';
import PropTypes from 'prop-types';
import styled, { ThemeConsumer } from 'styled-components';
import { themeGet } from 'styled-system';
import { Popper } from 'react-popper';
import { Box, getPaletteColor, deprecatedPropType, ThemeProvider } from 'pcln-design-system';
import FocusLock from 'react-focus-lock';
import PopoverArrow from '../Arrow';
import Overlay from '../Overlay';
import DEFAULT_MODIFIERS from '../helpers/defaultModifiers';

var PopoverContent = /*#__PURE__*/function (_Component) {
  _inherits(PopoverContent, _Component);

  var _super = _createSuper(PopoverContent);

  function PopoverContent() {
    var _this;

    _classCallCheck(this, PopoverContent);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));

    _defineProperty(_assertThisInitialized(_this), "handleKeyUp", function (evt) {
      var onCloseRequest = _this.props.onCloseRequest;
      var keys = {
        // Target ESC key
        27: function _() {
          onCloseRequest(evt);
        }
      };

      if (keys[evt.keyCode]) {
        evt.stopPropagation();
        evt.preventDefault();
        keys[evt.keyCode]();
      }
    });

    _defineProperty(_assertThisInitialized(_this), "calcOffset", function (placement) {
      // Need to account for the padding added around the popover, this fixes the offset at the start and end position
      if (RegExp('start*').test(placement)) {
        return '-16px';
      } else if (RegExp('end*').test(placement)) {
        return '16px';
      } else {
        return 0;
      }
    });

    return _this;
  }

  _createClass(PopoverContent, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      window.addEventListener('keyup', this.handleKeyUp, false);
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      window.removeEventListener('keyup', this.handleKeyUp, false);
    }
  }, {
    key: "getBorderColorName",
    value: function getBorderColorName(color, borderColor) {
      var borderColorName = borderColor;

      if (!borderColor) {
        if (color) {
          borderColorName = color;
        } else {
          borderColorName = 'border.base';
        }
      }

      return borderColorName;
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props = this.props,
          className = _this$props.className,
          contentRef = _this$props.contentRef,
          idx = _this$props.idx,
          onCloseRequest = _this$props.onCloseRequest,
          overlayOpacity = _this$props.overlayOpacity,
          placement = _this$props.placement,
          renderContent = _this$props.renderContent,
          trapFocus = _this$props.trapFocus,
          hideArrow = _this$props.hideArrow,
          hideOverlay = _this$props.hideOverlay;
      var styleProps = {
        borderColor: this.getBorderColorName(this.props.color, this.props.borderColor),
        zIndex: this.props.zIndex,
        width: this.props.width
      };
      var color = this.props.color ? this.props.color : 'background.lightest';
      var content = trapFocus ? /*#__PURE__*/React.createElement(FocusLock, null, renderContent({
        handleClose: onCloseRequest
      })) : renderContent({
        handleClose: onCloseRequest
      });

      var modifiers = _objectSpread(_objectSpread({}, DEFAULT_MODIFIERS), {}, {
        offset: {
          offset: this.calcOffset(placement)
        }
      });

      return /*#__PURE__*/ReactDOM.createPortal( /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Popper, _extends({
        positionFixed: true,
        modifiers: modifiers
      }, this.props), function (_ref) {
        var placement = _ref.placement,
            ref = _ref.ref,
            style = _ref.style,
            arrowProps = _ref.arrowProps;
        return /*#__PURE__*/React.createElement(PopperGuide, _extends({
          className: className,
          ref: ref,
          style: style,
          "data-placement": placement
        }, styleProps, {
          role: "dialog",
          "aria-describedby": "dialog-description-".concat(idx)
        }), /*#__PURE__*/React.createElement(ThemeConsumer, null, function (theme) {
          return /*#__PURE__*/React.createElement(ThemeProvider, {
            theme: theme
          }, /*#__PURE__*/React.createElement(ContentContainer, _extends({
            ref: contentRef
          }, styleProps, {
            tabIndex: "-1"
          }), /*#__PURE__*/React.createElement(Box, {
            color: color,
            "data-testid": "dialog-content",
            id: "popover-description-".concat(idx),
            borderRadius: "xl",
            tabIndex: "-1"
          }, content)));
        }), !hideArrow && /*#__PURE__*/React.createElement(PopoverArrow, {
          arrowProps: arrowProps,
          placement: placement,
          color: color,
          borderColor: styleProps.borderColor
        }));
      }), !hideOverlay && /*#__PURE__*/React.createElement(Overlay, {
        handleClick: onCloseRequest,
        zIndex: styleProps.zIndex - 1,
        overlayOpacity: overlayOpacity
      })), // Append each instance of the Popover as portal directly to the body
      document.querySelector('body'));
    }
  }]);

  return PopoverContent;
}(Component);

var PopperGuide = styled(Box).withConfig({
  displayName: "PopoverContent__PopperGuide",
  componentId: "sc-17m9nsb-0"
})(["padding:16px;z-index:", ";max-width:", ";width:100%;box-sizing:border-box;"], function (_ref2) {
  var zIndex = _ref2.zIndex;
  return zIndex < 0 ? 1 : zIndex;
}, function (_ref3) {
  var width = _ref3.width;
  return typeof width === 'number' ? "".concat(width, "px") : width;
});
var ContentContainer = styled.section.withConfig({
  displayName: "PopoverContent__ContentContainer",
  componentId: "sc-17m9nsb-1"
})(["box-shadow:0 0 0 1px ", ",0 0 4px 0 rgba(0,0,0,0.08),0 8px 8px 0 rgba(0,0,0,0.08),0 16px 16px 0 rgba(0,0,0,0.08);font-size:", "px;border-radius:", ";box-sizing:border-box;outline:0;max-width:100%;"], function (props) {
  return getPaletteColor(props.borderColor, 'base')(props);
}, themeGet('fontSizes.0'), themeGet('borderRadii.xl'));
PopoverContent.propTypes = {
  idx: PropTypes.oneOfType([PropTypes.number, PropTypes.string]).isRequired,
  // ID needs to be required for A11y purposes. We need to uniquely identify each popover on screen
  renderContent: PropTypes.func.isRequired,
  onCloseRequest: PropTypes.func.isRequired,
  contentRef: PropTypes.object,
  className: PropTypes.string,
  p: PropTypes.number,
  color: PropTypes.string,
  bg: deprecatedPropType('color'),
  borderColor: PropTypes.string,
  placement: PropTypes.string,
  zIndex: PropTypes.number,
  width: PropTypes.number,
  overlayOpacity: PropTypes.number,
  trapFocus: PropTypes.bool,
  hideArrow: PropTypes.bool,
  hideOverlay: PropTypes.bool
};
PopoverContent.defaultProps = {
  p: 2,
  placement: 'top',
  zIndex: 102,
  width: 400
};
export default PopoverContent;